// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-filter-list {
  display: grid;
  gap: var(--admin-s1);
}

.au-filter-list__label {
  display: inline-flex;
  align-items: center;
  gap: var(--admin-s3);
}

.au-filter-list__checkbox {
  width: 11px;
  height: 11px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 2px;
  background: transparent;
}

.au-filter-list__checkbox.is-checked {
  background: var(--admin-accent);
  border-color: var(--admin-accent);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminFilterList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC","sourcesContent":[".au-filter-list {\n  display: grid;\n  gap: var(--admin-s1);\n}\n\n.au-filter-list__label {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--admin-s3);\n}\n\n.au-filter-list__checkbox {\n  width: 11px;\n  height: 11px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 2px;\n  background: transparent;\n}\n\n.au-filter-list__checkbox.is-checked {\n  background: var(--admin-accent);\n  border-color: var(--admin-accent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
